import { ExpandableItemsListDrawer } from '../../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { useManualFlow, type FlowProps } from '../../../hooks'
import { useStore } from '../../../store'
import type AppStore from '../../../store/AppStore'

export function usePriceShelfLabelFlow(store: AppStore): FlowProps {
  return useManualFlow(store)
}

export default function PriceShelfLabelExpandableList() {
  const store = useStore()
  const flow = usePriceShelfLabelFlow(store)
  return <ExpandableItemsListDrawer {...flow} />
}
